import { d, n, t, tc } from "@global/Utilities/i18n";
import type { App } from "vue";

export default {
    install: (app) => {
        app.config.globalProperties.$t = t;
        app.config.globalProperties.$tc = tc;
        app.config.globalProperties.$d = d;
        app.config.globalProperties.$n = n;
    },
} satisfies { install: (app: App) => void };
